import React from 'react';

import { Space, Text, Title } from '@mantine/core';

import { plural } from '../../utils/aliases';
import '../../css/main.css';
import { PAGE_DESCRIPTIONS } from './constants';

export default function PageFrame({
    type, children,
}) {
    const title = plural[type];
    const description = PAGE_DESCRIPTIONS[type];

    return (
        <>
            <Title order={1}>{title}</Title>
            {description && (
                <>
                    <Space h="4px" />
                    <Text maw={600}>{description}</Text>
                </>
            )}
            <Space h="16px" />
            {children}
        </>
    );
}
